// extracted by mini-css-extract-plugin
export default {"menu":"Student_menu__1tnC6","nav":"Student_nav__3Oebu"};